import { ReturnStates } from "./ReturnStates";

export enum ActionCodeIcons {
    REFUND = 'https://d1f6rj4sne1926.cloudfront.net/returns/return.png',
    EXCHANGE_PRODUCT = 'https://d1f6rj4sne1926.cloudfront.net/returns/exchange_product.png',
    EXCHANGE_VARIANT = 'https://d1f6rj4sne1926.cloudfront.net/returns/exchange_variant.png'
};

export enum ActionCodeReturnState {
    REFUND = ReturnStates.RETURN_CONFIRMATION,
    EXCHANGE_PRODUCT = ReturnStates.EXCHANGE_PRODUCT,
    EXCHANGE_VARIANT = ReturnStates.EXCHANGE_VARIANT,
}